import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { SupplierMapping } from '@synergy/models';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { Attribute } from '../../../../../../common/models/attribute';

export const CLEAR_SUPPLIER_ATTRIBUTE_MAPPINGS = 'CLEAR_SUPPLIER_ATTRIBUTE_MAPPINGS';
export const RECEIVE_SUPPLIER_ATTRIBUTE_MAPPING = 'RECEIVE_SUPPLIER_ATTRIBUTE_MAPPING';
export const RECEIVE_SUPPLIER_ATTRIBUTE_MAPPINGS = 'RECEIVE_SUPPLIER_ATTRIBUTE_MAPPINGS';

const receiveSupplierAttributeMappings = (supplierMappings: PaginatedResponse<SupplierMapping<Attribute>>) => {
    return {
        type: RECEIVE_SUPPLIER_ATTRIBUTE_MAPPINGS,
        supplierMappings,
    };
};

const receiveSupplierAttributeMapping = (supplierMapping: SupplierMapping<Attribute>) => {
    return {
        type: RECEIVE_SUPPLIER_ATTRIBUTE_MAPPING,
        supplierMapping,
    };
};

export const clearSupplierAttributeMappings = () => {
    return {
        type: CLEAR_SUPPLIER_ATTRIBUTE_MAPPINGS,
    };
};

export const fetchSupplierAttributesMapping = (supplierId: number, searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response =
            await api.contactsAndOrganizations.Supplier.SupplierDetail.AttributeMapping.getAttributeMapping(
                supplierId,
                searchParams
            );

        if (response.success) {
            dispatch(receiveSupplierAttributeMappings(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateSupplierAttributeMapping = (supplierId: number, supplierMapping: SupplierMapping<Attribute>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response =
            await api.contactsAndOrganizations.Supplier.SupplierDetail.AttributeMapping.updateAttributeMapping(
                supplierId,
                supplierMapping
            );

        if (response.success) {
            dispatch(receiveSupplierAttributeMapping(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
